var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userData
    ? _c(
        "div",
        [
          _c(
            "Modal",
            {
              attrs: {
                value: _vm.pricingModal,
                modalName: "Choose your billing plan",
                maxWidth: "1000px",
                top: "auto",
                loading: _vm.subscriptionIsUpdating,
              },
              on: { input: _vm.closePricingModal },
            },
            [
              _c(
                "div",
                { staticClass: "pb-28" },
                [
                  _c("PlanCards", {
                    attrs: {
                      switchPlanAction: _vm.switchPlanAction,
                      currentDeal: _vm.currentDeal,
                    },
                    on: {
                      "subscribe-to": _vm.paddleCheckout,
                      "switch-to": _vm.proRateOnDealSwitch,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm.currentDeal
            ? _c(
                "Modal",
                {
                  attrs: {
                    value: _vm.updateSeatsModal,
                    modalName: "Update quantity of licenses",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.toggleModal({ name: "updateSeatsModal" })
                    },
                  },
                },
                [
                  _vm.currentDealIsBulk
                    ? _c("div", { staticClass: "modal-pro-options" }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "On Bulk offer, you can update the number of licenses by changing the number of bulks."
                            ),
                          ]),
                        ]),
                        _c("p", [
                          _vm._v("Right now you have "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.currentDeal.quantity) + " bulk"),
                          ]),
                          _vm._v(" that gives you "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.currentDeal.licensesQuantity) +
                                " licenses"
                            ),
                          ]),
                          _vm._v("."),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Change the number of bulks to add or remove " +
                              _vm._s(_vm.currentDeal.licensesQuantity) +
                              " licenses."
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            "Every bulk of licenses added will be charged separately according to the current pricing plan."
                          ),
                        ]),
                        _c("div", { staticClass: "subscribe__item-qty-text" }, [
                          _vm._v("\n        new quantity:\n      "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "subscribe__item-qty" },
                          [
                            _c("integer-plusminus", {
                              attrs: {
                                value: _vm.currentDeal.quantity,
                                min: 1,
                              },
                              on: {
                                input: (val) =>
                                  (_vm.updatedNumberOfLicenses = val),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "modal-pro-options__button",
                            attrs: {
                              disabled:
                                _vm.subscriptionIsUpdating ||
                                _vm.updatedNumberOfLicenses === 0 ||
                                _vm.updatedNumberOfLicenses ===
                                  _vm.currentDeal.quantity,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateNumberOfLicenses()
                              },
                            },
                          },
                          [_vm._v("SAVE")]
                        ),
                      ])
                    : _c("div", { staticClass: "modal-pro-options" }, [
                        _c("p", [
                          _vm._v("Right now you have "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.currentDeal.quantity)),
                          ]),
                          _vm._v(" licenses."),
                        ]),
                        _c("p", [_vm._v("Choose the new license quantity.")]),
                        _c("p", [
                          _vm._v(
                            "Each license added will be charged separately according to the current pricing plan."
                          ),
                        ]),
                        _c("div", { staticClass: "subscribe__item-qty-text" }, [
                          _vm._v("\n        new quantity:\n      "),
                        ]),
                        _c(
                          "div",
                          { staticClass: "subscribe__item-qty" },
                          [
                            _c("integer-plusminus", {
                              attrs: {
                                value: _vm.currentDeal.quantity,
                                min: 1,
                              },
                              on: {
                                input: (val) =>
                                  (_vm.updatedNumberOfLicenses = val),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "modal-pro-options__button",
                            attrs: {
                              disabled:
                                _vm.subscriptionIsUpdating ||
                                _vm.updatedNumberOfLicenses === 0 ||
                                _vm.updatedNumberOfLicenses ===
                                  _vm.currentDeal.quantity,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateNumberOfLicenses()
                              },
                            },
                          },
                          [_vm._v("SAVE")]
                        ),
                      ]),
                ]
              )
            : _vm._e(),
          _vm.currentDeal
            ? _c(
                "Modal",
                {
                  attrs: {
                    value: _vm.proRateModal,
                    modalName: "Update Pricing Plan",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.toggleModal({ name: "proRateModal" })
                    },
                  },
                },
                [
                  _c("div", { staticClass: "modal-pro-options" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.paddleUpdatePreviewText),
                      },
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "modal-pro-options__button",
                        attrs: { disabled: _vm.subscriptionIsUpdating },
                        on: {
                          click: function ($event) {
                            return _vm.switchDeal(_vm.switchToDealId)
                          },
                        },
                      },
                      [_vm._v("PROCEED")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "Modal",
            {
              attrs: { modalName: "Success" },
              model: {
                value: _vm.paddleSuccessModal,
                callback: function ($$v) {
                  _vm.paddleSuccessModal = $$v
                },
                expression: "paddleSuccessModal",
              },
            },
            [
              _c("div", { staticClass: "modal-pro-options" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "50px",
                      height: "50px",
                      viewBox: "0 0 50 50",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    },
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              transform: "translate(-695.000000, -346.000000)",
                              fill: "#0FD37B",
                              "fill-rule": "nonzero",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  transform:
                                    "translate(472.000000, 249.000000)",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M260.666887,100.385145 C261.27017,100.735177 261.476883,101.506464 261.129643,102.110882 C260.779961,102.71955 260.001489,102.928078 259.393945,102.575574 C248.599406,96.3124562 234.798061,100.029912 228.564727,110.87987 C222.328953,121.734077 226.028912,135.614854 236.827714,141.880445 C238.851908,143.054906 241.021681,143.901922 243.281352,144.399976 C243.963902,144.550417 244.395555,145.224439 244.246689,145.906555 C244.097319,146.590981 243.420176,147.024403 242.735296,146.873448 C240.220129,146.319081 237.805172,145.376583 235.554772,144.070874 C223.549374,137.105202 219.436035,121.681842 226.366273,109.618826 C233.298952,97.5515626 248.657226,93.4169998 260.666887,100.385145 Z M271.822723,126.03334 C272.533968,126.152663 273.008381,126.783462 272.883671,127.44502 C272.358773,130.22946 271.322266,132.903505 269.809402,135.37549 C266.286326,141.131777 260.489261,145.252855 253.651213,146.865633 C252.944534,147.032306 252.226515,146.632225 252.052101,145.9741 C251.879507,145.322841 252.305251,144.664318 253.004871,144.49931 C259.149913,143.049981 264.355362,139.347654 267.524752,134.169246 C268.888487,131.940935 269.822148,129.53255 270.295004,127.024175 C270.420679,126.357506 271.106234,125.913136 271.822723,126.03334 Z M264.599371,108.813663 C265.178776,108.185461 266.157736,108.145903 266.785938,108.725308 C267.41414,109.304714 267.453698,110.283673 266.874292,110.911875 L266.874292,110.911875 L244.651665,135.006062 L233.363925,122.164288 C232.799716,121.522402 232.862686,120.544669 233.504572,119.980461 C234.146457,119.416252 235.12419,119.479222 235.688398,120.121108 L235.688398,120.121108 L244.565179,130.219995 L244.852642,130.223435 Z M272.663237,119.485318 C272.829957,120.408591 272.941819,121.338484 272.998338,122.270986 C273.034077,122.860631 272.488979,123.367112 271.783239,123.40065 C271.07179,123.434459 270.459042,122.974356 270.422948,122.378857 C270.370699,121.516815 270.26729,120.657173 270.113174,119.803701 C270.008691,119.22509 270.482617,118.680039 271.174527,118.58208 C271.882908,118.481788 272.555724,118.889928 272.663237,119.485318 Z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c("p", [_vm._v("Your subscription was successfully updated")]),
                _c(
                  "button",
                  {
                    staticClass: "modal-pro-options__button",
                    on: {
                      click: function ($event) {
                        _vm.paddleSuccessModal = false
                      },
                    },
                  },
                  [_vm._v("OK")]
                ),
              ]),
            ]
          ),
          _c(
            "Modal",
            {
              attrs: { modalName: "Error" },
              model: {
                value: _vm.paddleErrorModal,
                callback: function ($$v) {
                  _vm.paddleErrorModal = $$v
                },
                expression: "paddleErrorModal",
              },
            },
            [
              _c("div", { staticClass: "modal-pro-options" }, [
                _c("p", [_vm._v("There was an error, please try again later")]),
                _c("p", [_vm._v(_vm._s(_vm.paddleUpdateError))]),
                _c(
                  "button",
                  {
                    staticClass: "modal-pro-options__button",
                    on: {
                      click: function ($event) {
                        _vm.paddleErrorModal = false
                      },
                    },
                  },
                  [_vm._v("OK")]
                ),
              ]),
            ]
          ),
          _vm.currentDeal
            ? _c(
                "Modal",
                {
                  attrs: { modalName: "Your subscription is canceled" },
                  model: {
                    value: _vm.paddleCancellationResultModal,
                    callback: function ($$v) {
                      _vm.paddleCancellationResultModal = $$v
                    },
                    expression: "paddleCancellationResultModal",
                  },
                },
                [
                  _c("div", { staticClass: "unsubscribe-modal" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "unsubscribe-modal__content-wrap text--align-center",
                      },
                      [
                        _c("p", [
                          _vm._v(
                            "Your paid plan will expire on " +
                              _vm._s(_vm.dealExpirationDate) +
                              " and your websites will be downgraded to Free. After that, all the paid features will become unavailable on your website."
                          ),
                        ]),
                        _c("p", [_vm._v("You are welcome back anytime!")]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "unsubscribe-modal__btns justify-center" },
                      [
                        _c(
                          "UiBtn",
                          {
                            attrs: { wide: "", type: "secondary" },
                            on: {
                              click: function ($event) {
                                _vm.paddleCancellationResultModal = false
                              },
                            },
                          },
                          [_vm._v("\n          Ok\n        ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "Modal",
            {
              attrs: {
                value: _vm.seatsRequestModal,
                modalName: "You’ve reached the license limit",
              },
              on: {
                input: function ($event) {
                  return _vm.toggleModal({ name: "seatsRequestModal" })
                },
              },
            },
            [
              _c("div", { staticClass: "modal-pro-options" }, [
                _c("p", [
                  _vm._v(
                    "If you need more licenses, please ask the workspace owner to update their subscription plan, or downgrade one of the existing websites to Free."
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "modal-pro-options__button",
                    on: {
                      click: function ($event) {
                        return _vm.toggleModal({ name: "seatsRequestModal" })
                      },
                    },
                  },
                  [_vm._v("OK")]
                ),
              ]),
            ]
          ),
          _vm.currentDeal
            ? _c("UnsubscribeQuiz", {
                attrs: {
                  value: _vm.unSubscriptionQuizModal,
                  currentDeal: _vm.currentDeal,
                },
                on: {
                  unsubscribe: _vm.cancelSubscription,
                  close: function ($event) {
                    return _vm.toggleModal({ name: "unSubscriptionQuizModal" })
                  },
                },
              })
            : _vm._e(),
          _c(
            "Modal",
            {
              staticClass: "confirmation-popup",
              attrs: {
                value: _vm.addMoreSeatsInfoModal,
                modalName: "You’ve reached your licenses limit",
                closeOnPressEscBtn: "",
                alignTitleLeft: "",
              },
              on: {
                input: function ($event) {
                  return _vm.toggleModal({ name: "addMoreSeatsInfoModal" })
                },
              },
            },
            [
              _c("div", { staticClass: "confirmation-popup__content" }, [
                _c("p", [
                  _vm._v("There are no available licenses on your plan."),
                ]),
                _c("p", [
                  _vm._v(
                    "To apply this type of license to a website, do one of the following steps:"
                  ),
                ]),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "downgrade one of the existing websites to Free in your workspace"
                    ),
                  ]),
                  _c(
                    "li",
                    [
                      _vm._v("add more licenses in your "),
                      _c(
                        "router-link",
                        { attrs: { to: { name: "account-billing" } } },
                        [_vm._v("Billing Settings")]
                      ),
                      _vm._v("."),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "confirmation-popup__btns" },
                [
                  _c(
                    "UiBtn",
                    {
                      attrs: { type: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleModal({
                            name: "addMoreSeatsInfoModal",
                          })
                        },
                      },
                    },
                    [_vm._v("OK")]
                  ),
                  _c(
                    "UiBtn",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goToBilling },
                    },
                    [_vm._v("ADD MORE LICENSES")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "Modal",
            {
              staticClass: "confirmation-popup",
              attrs: {
                value: _vm.offerToChangeWebsitePlan,
                modalName:
                  "This feature is not available on your current subscription plan",
                closeOnPressEscBtn: "",
                alignTitleLeft: "",
              },
              on: {
                input: function ($event) {
                  return _vm.toggleModal({ name: "offerToChangeWebsitePlan" })
                },
              },
            },
            [
              _c("div", { staticClass: "confirmation-popup__content" }, [
                _c("p", [
                  _vm._v(
                    "You cannot enable this feature with the current license applied to this website."
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    "Please apply a different license to the website to use this feature."
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "confirmation-popup__btns" },
                [
                  _c(
                    "UiBtn",
                    {
                      attrs: { type: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleModal({
                            name: "offerToChangeWebsitePlan",
                          })
                        },
                      },
                    },
                    [_vm._v("OK")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("Preloader", { attrs: { loading: _vm.subscriptionIsUpdating } }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }